import React from 'react';
import { PRICE } from './salesData';
interface PriceBlockProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  /** 'inline' comprime el bloque en una fila (hero mobile). */
  layout?: 'stack' | 'inline';
  tone?: 'light' | 'dark';
}

/**
 * Único bloque de precio de la landing: precio anterior tachado en topo,
 * etiqueta de oferta en frambuesa y precio vigente grande en chocolate.
 */
export function PriceBlock({
  className = '',
  size = 'md',
  layout = 'stack',
  tone = 'light'
}: PriceBlockProps) {
  const current = size === 'lg' ? 'text-[3rem] sm:text-[3.6rem]' : size === 'sm' ? 'text-[2.1rem] sm:text-[2.5rem]' : 'text-[2.6rem] sm:text-[3.1rem]';
  const previousColor = tone === 'dark' ? 'text-white/50' : 'text-taupe';
  const currentColor = tone === 'dark' ? 'text-white' : 'text-charcoal';
  const noteColor = tone === 'dark' ? 'text-white/60' : 'text-taupe';
  if (layout === 'inline') {
    return <div className={`flex flex-col items-center ${className}`} data-id="element-200" data-mp="werwoz8sdkxt">
        <span className="rounded-full bg-gold px-2.5 py-0.5 font-display text-[0.6rem] font-bold uppercase tracking-[0.1em] text-white" data-id="element-201" data-mp="1ryyndhy3x9u2">
          Oferta especial
        </span>
        <div className="mt-1.5 flex items-baseline justify-center gap-2.5" data-id="element-202" data-mp="21pb5l3ig8qx1">
          <p className={`font-sans text-[0.95rem] font-medium tabular-nums ${previousColor}`} data-id="element-203" data-mp="26oebeq697162">
            <span className="mr-1 text-[0.72rem] font-semibold uppercase tracking-[0.08em]" data-id="element-204" data-mp="190vugs2fusqz">
              Antes
            </span>
            <span style={{
            textDecoration: 'line-through'
          }} data-id="element-205" data-mp="1e11o2ds9qpbp">{PRICE.previous}</span>
          </p>
          <p className={`font-display font-extrabold leading-none tracking-tight tabular-nums ${current} ${currentColor}`} data-id="element-206" data-mp="1iy0fupogmk6q">
            {PRICE.current}
          </p>
        </div>
        <p className={`mt-1.5 font-sans text-[0.68rem] font-semibold uppercase tracking-[0.1em] ${noteColor}`} data-id="element-207" data-mp="2ud6z5zcq22pl">
          {PRICE.note}
        </p>
      </div>;
  }
  return <div className={`flex flex-col items-center ${className}`} data-id="element-208" data-mp="za0tftxy02dk">
      <span className="rounded-full bg-gold px-2.5 py-0.5 font-display text-[0.62rem] font-bold uppercase tracking-[0.1em] text-white" data-id="element-209" data-mp="ubzb5b8cc735">
        Oferta especial
      </span>
      <p className={`mt-1.5 font-sans text-sm font-medium tabular-nums ${previousColor}`} data-id="element-210" data-mp="189nwek6blg8q">
        <span className="mr-1 text-[0.7rem] font-semibold uppercase tracking-[0.1em]" data-id="element-211" data-mp="13dgmyheptmm1">Antes</span>
        <span style={{
        textDecoration: 'line-through'
      }} data-id="element-212" data-mp="fncmgiwtq2z9">{PRICE.previous}</span>
      </p>
      <p className={`mt-0.5 font-display font-extrabold leading-[0.95] tracking-tight tabular-nums ${current} ${currentColor}`} data-id="element-213" data-mp="bn2g3554dajv">
        {PRICE.current}
      </p>
      <p className={`mt-2.5 max-w-[34ch] font-sans text-[0.74rem] font-semibold leading-snug ${tone === 'dark' ? noteColor : 'text-gold-deep'}`} data-id="element-214" data-mp="kl4nq3jcz1g4">
        {PRICE.note}
      </p>
    </div>;
}